<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/The_Proud_Sinner2#Contents-A">Dedication</a></p>
<p class="Body-Center para-style-override-3"><span class="Italic">To Paula Mildenhall, my Australian friend, <br/>who owns a heart as big as her wonderful country.</span></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Proud_Sinner-3.vue?4b9d47e0